import HttpCliente from '../HttpCliente';
import { guardarSesion, limpiarSesion } from '../sesion';

export const usuario = {
    Id: undefined,
    Nombre: '',
    Apellido: '',
    Email: '',
    Password: '',
  };

export const loginModel = {
    Email: '',  // Cambio aquí
    Password: '',  // Cambio aquí
};

/**
 * POST method - Inicia sesión con un usuario
 * @param {loginUsuario} usuario a iniciar sesión
 * @param {function} setLoginError función para establecer mensaje de error
 * @param {function} setToken función para establecer el token
 * @return {Promise} Promesa de obtención
 */
export const loginUser = (loginUsuario, setLoginError, setToken) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Usuario/Login", loginUsuario, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            // El backend responde { token, refreshToken, expiresIn }
            const token = guardarSesion(response.data);
            if (!token) {
                setLoginError("Respuesta de autenticación inválida");
                reject("Respuesta inválida");
                return;
            }
            setToken(token);
            resolve(token);
        })
        .catch(error => {
            console.error('Error completo durante el inicio de sesión:', error);
            
            if (error.response && error.response.data) {
                const responseData = error.response.data; // No es necesario parsear, ya es un objeto JavaScript
                setLoginError(responseData); // Establecer el estado de Error
            } else {
                setLoginError("Error de conexión con el servidor");
                reject("Error de conexión"); // Manejar errores de conexión
            }
        });
    });
};

/**
 * POST method - Inicia sesión con un proveedor externo
 */
export const externalLoginUser = (provider, idToken, setLoginError, setToken) => {
  return new Promise((resolve, reject) => {
    const externalAuthData = {
      Provider: provider,
      IdToken: idToken
    };
    
    HttpCliente.post("/Usuario/ExternalLogin", externalAuthData, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      // El backend responde { token, refreshToken, expiresIn }
      const token = guardarSesion(response.data);
      if (!token) {
        setLoginError("Respuesta de autenticación inválida");
        reject("Respuesta inválida");
        return;
      }
      setToken(token);
      resolve(token);
    })
    .catch(error => {
      console.error('Error en login externo:', error);
      if (error.response && error.response.data) {
        setLoginError(typeof error.response.data === 'string' 
          ? error.response.data 
          : "Error al iniciar sesión con proveedor externo");
      } else {
        setLoginError("Error de conexión con el servidor");
      }
      reject(error);
    });
  });
};

/**
 * Verifica si el usuario está autenticado
 */
export const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
};

/**
 * Cierra la sesión del usuario
 */
export const logout = () => {
    limpiarSesion();
    window.location.href = '/login';
};